import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

const getUsers = () => JSON.parse(localStorage.getItem('lux_users') || '[]');
const saveUsers = (users) => localStorage.setItem('lux_users', JSON.stringify(users));

const getInitialUser = () => {
  const email = localStorage.getItem('lux_current_user');
  if (email) {
    const found = getUsers().find((u) => u.email === email);
    if (found) return found;
  }
  return null;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getInitialUser);

  const login = useCallback((email, password) => {
    const found = getUsers().find((u) => u.email === email && u.password === password);
    if (!found) return { ok: false, error: 'wrongCredentials' };
    localStorage.setItem('lux_current_user', email);
    setUser(found);
    return { ok: true };
  }, []);

  const register = useCallback(({ email, password, firstName, lastName }) => {
    const users = getUsers();
    if (users.find((u) => u.email === email)) return { ok: false, error: 'emailExists' };
    const newUser = { email, password, firstName, lastName, phone: '', gender: '' };
    users.push(newUser);
    saveUsers(users);
    localStorage.setItem('lux_current_user', email);
    setUser(newUser);
    return { ok: true };
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('lux_current_user');
    setUser(null);
  }, []);

  const updateProfile = useCallback((fields) => {
    const users = getUsers();
    const idx = users.findIndex((u) => u.email === user?.email);
    if (idx === -1) return;
    const updated = { ...users[idx], ...fields };
    users[idx] = updated;
    saveUsers(users);
    setUser(updated);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
};
